import { render, staticRenderFns } from "./SubscriptionPlanCard.vue?vue&type=template&id=2132f47d&scoped=true&"
import script from "./SubscriptionPlanCard.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionPlanCard.vue?vue&type=script&lang=ts&"
import style0 from "./SubscriptionPlanCard.vue?vue&type=style&index=0&id=2132f47d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2132f47d",
  null
  
)

export default component.exports